import React from 'react'
import InputForm from '../../components/InputForm'
import NavigationBar from '../../components/NavigationBar'
import { Container, Row, Col } from 'react-bootstrap'

const AddServicePage = () => {
    return (
        <>
                <NavigationBar />
            <Container>
                <Row className="mb-2 mt-5">
                    <Col>
                        <h1>Add Service</h1>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <InputForm />
                    </Col>
                </Row>

            </Container>
        </>
    )
}

export default AddServicePage
